import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function MatomoTracker() {
  const location = useLocation();
  const previousPathRef = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    if (window._paq) {
      if (previousPathRef.current) {
        window._paq.push(["setReferrerUrl", previousPathRef.current]);
      }

      window._paq.push(["setCustomUrl", currentPath]);
      window._paq.push(["setDocumentTitle", document.title]);
      window._paq.push(["trackPageView"]);
    }

    previousPathRef.current = currentPath;
  }, [location]);

  return null;
}
